import { Modal } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .MuiPaper-root {
    max-width: 680px;
  }
`;
